import http from '../../Utils/http';
const GenericDelete = {
  name: 'helpers',
  state: {
    id: 0,
    msg: null,
    loading: false,
    eligible: null,
    reason: null,
  },
  reducers: {
    deleteRequested(state) {
      return {
        id: 0,
        msg: null,
        loading: true,
        eligible: null,
        reason: null,
      };
    },

    deleteReceived(state, payload) {
      if (payload?.data?.message === 'active') {
        return {
          ...state,
          msg: 'This Organization cannot be Deleted Due to Active Campaigns.',
          loading: false,
        };
      } else {
        return {
          ...state,
          msg: null,
          loading: false,
        };
      }
    },

    deleteEligibilityReceived(state, payload) {
      return {
        ...state,
        eligibility: payload?.data?.eligible,
        reason: payload?.data?.reasons[0],
      };
    },

    deleteRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
      };
    },

    clearit(state) {
      return {
        ...state,
        msg: null,
      };
    },

    deleteEligibilityClean(state){
      return {
        ...state,
        eligibility: null,
        reason: null,
      };
    }
  },
  effects: (dispatch) => ({
    async _delete({ path, id }) {
      try {
        const response = await http.delete(`savvy/${path}/deactivate/${id}`);
        dispatch.ProgressStepDSO.GetDSOProgressStep(2);
        this.deleteReceived(response);
      } catch (err) {
        console.log(err);
      }
    },
    async _deleteOrganization({ path, id, type }) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const user_id = userInfo?.id;
        const response = await http.delete(`savvy/${path}/${id}?type=${type}&user_id=${user_id}`);
        this.deleteReceived(response);
        return response;
      } catch (err) {
        this.deleteRequestFailed(err);
        console.log(err);
      }
    },
    async _deleteOrganizationRequest({ path, id }) {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const user_id = userInfo?.id;
        const response = await http.delete(`savvy/${path}/request/${id}?user_id=${user_id}`);
        this.deleteReceived(response);
        return response;
      } catch (err) {
        this.deleteRequestFailed(err);
        console.log(err);
      }
    },

    async requestForEligibility() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const type = userInfo?.organization.type;
        const org_id = userInfo?.org_id;
        const response = await http.get(`savvy/campaigns/requestEligibility/${org_id}?type=${type}`);
        this.deleteEligibilityReceived(response);
        return response;
      } catch (err) {
        this.deleteRequestFailed(err);
        console.log(err);
      }
    },

    async cleanEligibilityReason(){
      this.deleteEligibilityClean();
    },

    async clear() {
      this.clearit();
    }
  }),

};

export default GenericDelete;
